import { fromJS } from 'immutable';
import moment from 'moment'
import { isDate } from 'moment';
import { GET_ENQUIRIES,GET_SEASONS,UPDATE_SEASONS,GET_CUSTOM_ITEMS} from "../actions/constants";

const initialTodos = {
	enquiries: [],
	seasons: [],
	seasons_days:[],
	season_today:null,
	customizer_items: [],
	custom_items: [],
	enquiry: {},
	contador: 0,
};

const enquiries = (state=initialTodos, action) => {
    var newState = Object.assign({}, state);
    const datos = fromJS(newState)

    switch (action.type) {
		case GET_ENQUIRIES:
			const enquiriesNew = datos.updateIn(["enquiries"], (value) => action.payload);
			var countNew = enquiriesNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case UPDATE_SEASONS:
			var seasons_days = [];
			var season_today = {};
			var today=moment().set({hour:0,minute:0,second:0,millisecond:0})
			var ano = moment().format("YYYY");
			const seasons2 = action.payload.map((s) => {
				if (s.id == "PEAK") {
					s.color = "#f0341f";
				} else if (s.id == "HIGH") {
					s.color = "#ffb748";
				} else if (s.id == "MID") {
					s.color = "#fbed63";
				} else if (s.id == "LOW") {
					s.color = "#6ac6f9";
				}
				//s.dates = s.dates.trim().replace(/\'/g, '"');
				//if (s.dates.trim() != "") {
					//s.dates = JSON.parse(s.dates);
					if (s.dates.length > 0) {
						for (var d of s.dates) {
							var desde = moment(ano + "/" + d.from, "YYYY/MM/DD");
							var hasta = moment(ano + "/" + d.to, "YYYY/MM/DD");
							if (hasta < desde) {
								hasta = moment(parseInt(ano) + 1 + "/" + d.to, "YYYY/MM/DD");
							}
							var cant = hasta.diff(desde, "days");
							
							for (var i = 0; i <= cant; i++) {
								var d_temp = i == 0 ? desde : desde.add(1, "days");
								if(today==desde) season_today={ month: d_temp.format("M"), day: d_temp.format("DD"), code:d_temp.format("MDD"), season: s.name, id: s.id, color: s.color }
								seasons_days.push({ month: d_temp.format("M"), day: d_temp.format("DD"), code:d_temp.format("MDD"), season: s.name, id: s.id, color: s.color });
							}
						}
					}
				/*} else {
					s.dates = [];
				}*/
				
				return s;
			});
			const seasonsTodayUpdate = datos.updateIn(["season_today"], (value) => season_today);
			const seasonsDaysNew2 = seasonsTodayUpdate.updateIn(["seasons_days"], (value) => seasons_days);
			const seasonsNew2 = seasonsDaysNew2.updateIn(["seasons"], (value) => seasons2);
			var countNew = seasonsNew2.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_SEASONS:
			var seasons_days = [];
			var season_today = {};
			var today=moment().set({hour:0,minute:0,second:0,millisecond:0})
			var ano = moment().format("YYYY");
			const seasons = action.payload.map((s) => {
				if (s.id == "PEAK") {
					s.color = "#f0341f";
				} else if (s.id == "HIGH") {
					s.color = "#ffb748";
				} else if (s.id == "MID") {
					s.color = "#fbed63";
				} else if (s.id == "LOW") {
					s.color = "#6ac6f9";
				}
				//s.dates = s.dates.trim().replace(/\'/g, '"');
				//if (s.dates.trim() != "") {
					s.dates = JSON.parse(s.dates);
					if (s.dates.length > 0) {
						for (var d of s.dates) {
							var desde = moment(ano + "/" + d.from, "YYYY/MM/DD");
							var hasta = moment(ano + "/" + d.to, "YYYY/MM/DD");
							if (hasta < desde) {
								hasta = moment(parseInt(ano) + 1 + "/" + d.to, "YYYY/MM/DD");
							}
							var cant = hasta.diff(desde, "days");
							for (var i = 0; i <= cant; i++) {
								var d_temp = i == 0 ? desde : desde.add(1, "days");
								
								if(today.format("YYYYMMDD")==desde.format("YYYYMMDD")) {
									season_today={ month: d_temp.format("M"), day: d_temp.format("DD"), code:d_temp.format("MDD"), season: s.name, id: s.id, color: s.color }
								}
								seasons_days.push({ month: d_temp.format("M"), day: d_temp.format("DD"), code: d_temp.format("MDD"), season: s.name, id: s.id, color: s.color });
							}
						}
					}
				/*} else {
					s.dates = [];
				}*/
				return s;
			});
			const seasonsTodayNew = datos.updateIn(["season_today"], (value) => season_today);
			const seasonsDaysNew = seasonsTodayNew.updateIn(["seasons_days"], (value) => seasons_days);
			const seasonsNew = seasonsDaysNew.updateIn(["seasons"], (value) => seasons);
			var countNew = seasonsNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case GET_CUSTOM_ITEMS:
			var custom_items = [];
			const items = action.payload.map((i) => {
				var pos_i = custom_items.findIndex((it) => {
					return it.step == i.step;
				});
				if (pos_i < 0) {
					custom_items.push({ step: i.step, items: [] });
					pos_i = custom_items.length - 1;
				}
				i.options = JSON.parse(i.options);
				if (i.name.includes("ACTIVIT")) {
					i.dato = i.name.toLowerCase().replace("_", "");
				} else if (i.name.includes("MEALS")) {
					var t = i.name.split("_")[1];
					i.dato = "meals" + t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
				} else if (i.name.includes("TRANSPORT")) {
					var t = i.name.split("_")[1];
					i.dato = "transport" + t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
					if (i.dato == "transportSanjose") {
						i.dato = "transportSanJose";
					}
				}
				custom_items[pos_i].items.push(i);
				return i;
			});

			var seasons_days = [];
			var ano = moment().format("YYYY");
			const seasons_1 = action.seasons.map((s) => {
				if (s.id == "PEAK") {
					s.color = "#f0341f";
				} else if (s.id == "HIGH") {
					s.color = "#ffb748";
				} else if (s.id == "MID") {
					s.color = "#fbed63";
				} else if (s.id == "LOW") {
					s.color = "#6ac6f9";
				}
				//s.dates = s.dates.trim().replace(/\'/g, '"');
				
				//if (s.dates.trim() != "") {
					s.dates = JSON.parse(s.dates);
					if (s.dates.length > 0) {
						for (var d of s.dates) {
							var desde = moment(ano + "/" + d.from, "YYYY/MM/DD");
							var hasta = moment(ano + "/" + d.to, "YYYY/MM/DD");
							if (hasta < desde) {
								hasta = moment(parseInt(ano) + 1 + "/" + d.to, "YYYY/MM/DD");
							}
							var cant = hasta.diff(desde, "days");
							for (var i = 0; i <= cant; i++) {
								var d_temp = i == 0 ? desde : desde.add(1, "days");
								seasons_days.push({ month: d_temp.format("M"), day: d_temp.format("DD"), code: d_temp.format("MDD"), season: s.name, id: s.id, color: s.color });
							}
						}
					}
				/*} else {
					s.dates = [];
				}*/
				
				return s;
			});

			const seasonsDaysNew1 = datos.updateIn(["seasons_days"], (value) => seasons_days);
			const seasonsNew1 = seasonsDaysNew1.updateIn(["seasons"], (value) => seasons_1);
			const c_itemsNew = seasonsNew1.updateIn(["custom_items"], (value) => custom_items);
			const itemsNew = c_itemsNew.updateIn(["customizer_items"], (value) => items);
			var countNew = itemsNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		default:
			return state;
	}
}

export default enquiries